import { defineMessages } from 'react-intl';

export default defineMessages({
    heading: {
        id: '_.recommended_offer_view.heading',
        defaultMessage: "You're approved for up to {amount}"
    },
    relevantOfferLabel: {
        id: '_.recommended_offer_view.offer_details.relevant_offer_label',
        defaultMessage: 'Our most relevant offer for you:'
    },
    relevantOfferText: {
        id: '_.recommended_offer_view.offer_details.relevant_offer_text',
        defaultMessage:
            'You want to borrow funds for {requestedDuration} for {requestedPurpose}.'
    },
    withdrawalAmountLabel: {
        id: '_.recommended_offer_view.withdrawal_amount_label',
        defaultMessage: 'How much do you want to withdraw? {input}'
    },
    disclaimerText: {
        id: '_.recommended_offer_view.disclaimer_text',
        defaultMessage:
            'You will have full flexibility to repay early for free, and the ability to access additional funds at a later date too.'
    },
    CTAText: {
        id: '_.recommended_offer_view.cta_text',
        defaultMessage: 'Continue to final checks'
    },
    offerDetailsHeading: {
        id: '_.recommended_offer_view.offer_details.heading',
        defaultMessage: 'Your offer details'
    },
    offerValidity: {
        id: '_.recommended_offer_view.offer_details.timeout',
        defaultMessage: 'This offer is valid until {timeout}'
    },
    interestOnlyShowDetailsLabel: {
        id: '_.recommended_offer_view.interest_only.repayment_breakdown.show_details',
        defaultMessage: 'show details'
    },
    monthlyRepaymentLabel: {
        id: '_.recommended_offer_view.offer_details.monthly_repayment',
        defaultMessage: 'Monthly repayment'
    },
    totalRepaymentLabel: {
        id: '_.recommended_offer_view.offer_details.total_repayment',
        defaultMessage: 'Total repayment'
    },
    repaymentscheduleModalText: {
        id: '_.recommended_offer_view.offer_details.repayment_schedule_modal',
        defaultMessage: 'See my repayment schedule'
    },
    savingsCalculatorModalText: {
        id: '_.recommended_offer_view.offer_details.savings_calculator_modal',
        defaultMessage: 'Save by repaying early'
    },
    seeAllOptionsText: {
        id: '_.recommended_offer_view.offer_details.see_all_options',
        defaultMessage:
            'This is not financial advice and you can explore your full range of options.'
    },
    seeAllOptionsBtn: {
        id: '_.recommended_offer_view.offer_details.see_all_options_btn',
        defaultMessage: 'Show me all of my options'
    },
    discountedOffer: {
        id: '_.recommended_offer_view.offer_details.discountedOffer',
        defaultMessage: 'Our offer for you:'
    }
});
